module.exports = " <div class=scrollbar _v-84377d3e=\"\"> <div class=mdl-card__title _v-84377d3e=\"\"> <h4 class=mdl-card__title-text _v-84377d3e=\"\">{{title}}</h4> </div> <div class=mdl-card__supporting-text :class=\"{scrollbar: scroll}\" _v-84377d3e=\"\"> {{{text}}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-84377d3e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/segments/DelayedDetails.vue
// module id = 366
// module chunks = 0